export class BestAddress{
    values: Array<BestAddressItem>;
    item: BestAddressItem;

    public static mergeJSON(instance: any, data: any): BestAddress{
        if (!data) { return instance; }
        instance.item = new BestAddressItem().fromJSON(data);
        //We currently receive only one bestAddressItem with the proprs directly in the body => data in this function
        /*if (data.values != null) {
            instance.values = [];
            ([].concat(data.values)).forEach(occurrence => {
                instance.values.push(new BestAddressItem().fromJSON(occurrence)); // i3
            });
        }*/
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return BestAddress.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: BestAddress) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return BestAddress.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: BestAddress): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }
}

export class BestAddressItem{
    fid: number;
    id: number;
    fed_address_id: string;
    best_namespace: string;
    best_objectid: string;
    best_versionid: string;
    best_id: string;
    housenumber: string;
    status: string;
    status_valid_from: string;
    position: string;
    begin_life_span_version: string;
    officialy_assigned: string;

    postal_info_namespace: string;
    postal_info_objectid: string;
    postal_info_versionid: string;

    streetname: string; //Not in API model
    streetname_namespace: string;
    streetname_objectid: string;
    streetname_versionid: string;

    municipality: string; //Not in API model
    municipality_namespace: string;
    municipality_versionid: string;
    municipality_objectid: string;

    part_of_municipality: string; //Not in API model
    part_of_municipality_namespace: string;
    part_of_municipality_versionid: string;
    part_of_municipality_objectid: string;

    namedut: string;
    namefre: string;

    cantonheadoffice: string;
    cantoncodedut: string;
    cantoncodefre: string;

    public static mergeJSON(instance: BestAddressItem, data: BestAddressItem): BestAddressItem {
        if(!data) { return instance; }
        if(data.fid != null){instance.fid = data.fid}
        if(data.id != null){instance.id = data.id}
        if(data.fed_address_id != null){instance.fed_address_id = data.fed_address_id}
        if(data.best_namespace != null){instance.best_namespace = data.best_namespace}
        if(data.best_objectid != null){instance.best_objectid = data.best_objectid}
        if(data.best_versionid != null){instance.best_versionid = data.best_versionid}
        if(data.best_id != null){instance.best_id = data.best_id}

        if(data.housenumber != null){instance.housenumber = data.housenumber}
        if(data.status != null){instance.status = data.status}
        if(data.status_valid_from != null){instance.status_valid_from = data.status_valid_from}
        if(data.position != null){instance.position = data.position}
        if(data.begin_life_span_version != null){instance.begin_life_span_version = data.begin_life_span_version}
        if(data.officialy_assigned != null){instance.officialy_assigned = data.officialy_assigned}

        if(data.postal_info_namespace != null){instance.postal_info_namespace = data.postal_info_namespace}
        if(data.postal_info_objectid != null){instance.postal_info_objectid = data.postal_info_objectid}
        if(data.postal_info_versionid != null){instance.postal_info_versionid = data.postal_info_versionid}

        if(data.streetname_namespace != null){instance.streetname_namespace = data.streetname_namespace}
        if(data.streetname_objectid != null){instance.streetname_objectid = data.streetname_objectid}
        if(data.streetname_versionid != null){instance.streetname_versionid = data.streetname_versionid}
        if(data.streetname){instance.streetname = data.streetname }

        if(data.municipality_namespace != null){instance.municipality_namespace = data.municipality_namespace}
        if(data.municipality_versionid != null){instance.municipality_versionid = data.municipality_versionid}
        if(data.municipality_objectid != null){instance.municipality_objectid = data.municipality_objectid}
        if(data.municipality != null ){ instance.municipality = data.municipality }

        if(data.part_of_municipality_namespace != null){instance.part_of_municipality_namespace = data.part_of_municipality_namespace}
        if(data.part_of_municipality_objectid != null){instance.part_of_municipality_objectid = data.part_of_municipality_objectid}
        if(data.part_of_municipality_versionid != null){instance.part_of_municipality_versionid = data.part_of_municipality_versionid}
        if(data.part_of_municipality != null){instance.part_of_municipality = data.part_of_municipality}

        if(data.namedut != null){instance.namedut = data.namedut}
        if(data.namefre != null){instance.namefre = data.namefre}

        if(data.cantonheadoffice != null){instance.cantonheadoffice = data.cantonheadoffice}
        if(data.cantoncodedut != null){instance.cantoncodedut = data.cantoncodedut}
        if(data.cantoncodefre  != null){instance.cantoncodefre = data.cantoncodefre}
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return BestAddressItem.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: BestAddressItem) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return BestAddressItem.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: BestAddressItem): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }
}
